export function createListenerRegistry() {
  const cleanupCallbacks = [];

  return {
    add(target, event, handler, options) {
      if (!target) return;
      target.addEventListener(event, handler, options);
      cleanupCallbacks.push(() => target.removeEventListener(event, handler, options));
    },

    registerCleanup(cleanupFn) {
      if (typeof cleanupFn === 'function') {
        cleanupCallbacks.push(cleanupFn);
      }
    },

    cleanupAll() {
      cleanupCallbacks.forEach(fn => {
        try {
          fn();
        } catch (_) {
          // no-op
        }
      });
    }
  };
}
